import { createAction } from '@reduxjs/toolkit';
import * as constants from './constants';

export const addItem = createAction(constants.ADD_ITEM, (item) => ({ payload: { ...item, id: `${new Date().getTime()}` } }));
export const addItems = createAction(constants.ADD_ITEMS);
export const deleteItem = createAction(constants.DELETE_ITEM);
export const deleteItems = createAction(constants.DELETE_ITEMS);
